<template>
  <div class="spacing-px-15">
    <b-loading isFullPage :active="isLoading" />
    <div v-if="!process.giveup_request" class="column is-9">
      <TimelineItem
        :title="General.TO"
        stepValue="1"
        statusSize="large"
        statusColor="success"
      >
        <b-input :value="systemName" disabled />

        <label class="mt-30 mb-10 is-flex">
          <span class="is-size-5 has-text-weight-semibold">{{
            General.INTERESTED_GENERIC
          }}</span>
        </label>
        <div
          class="tag-list input"
          disabled="disabled"
          data-cy="STAKEHOLDER_INPUT"
        >
          <b-tag
            v-for="(tag, index) in stakeholderTagsData"
            :key="index"
            rounded
            type="is-white"
          >
            <div class="is-flex p-5">
              <b-icon icon="account-plus" size="is-small" />
              <span v-if="tag.user_cpf" class="ml-5">
                {{ tag.user_name }} - {{ tag.user_cpf }}
              </span>
            </div>
          </b-tag>
        </div>
      </TimelineItem>

      <TimelineItem
        :title="App.PendingDocumentsScreen.PENDING_DOCUMENTS"
        stepValue="2"
        statusSize="large"
        class="custom-timeline"
        :statusColor="isContrast ? 'default' : 'success'"
      >
        <div v-for="(doc, index) in selectedDocList" :key="index">
          <div class="columns">
            <b-select
              v-model="doc.process_file_id"
              :placeholder="App.PendingDocumentsScreen.SELECT_DOCUMENT"
              class="column is-8"
              expanded
              @input="resetReason(doc)"
            >
              <option
                v-for="(optionType, indexOptionsType) in pendingDocumentTypes(
                  index
                )"
                :key="indexOptionsType"
                :value="optionType.id"
              >
                {{ optionType.external_document_name }}
              </option>
            </b-select>
            <b-select
              v-model="doc.reason"
              :placeholder="App.PendingDocumentsScreen.SELECT_PENDING_REASON"
              class="column is-4"
              expanded
              :disabled="doc.process_file_id === -99"
            >
              <option
                v-for="(optionReason, indexOptionsReason) in pendencyReasons"
                :key="indexOptionsReason"
                :value="optionReason"
              >
                {{ optionReason }}
              </option>
            </b-select>
            <div
              class="column is-1 pl-0 is-flex is-align-items-center cursor-pointer"
              @click.stop="
                checkSingleDocument(index)
                  ? clearDocument(index)
                  : removeDocument(index)
              "
            >
              <b-icon
                icon="delete"
                :type="isContrast ? 'is-white' : 'is-blue-oil'"
              />
            </div>
          </div>
        </div>
        <div class="pt-10 mb-10">
          <b-button
            class="custom-decorate"
            type="is-text"
            @click="addPendingDocument()"
          >
            <div class="inner">
              <b-icon
                :type="isContrast ? 'is-white' : 'is-primary'"
                icon="plus-circle"
              />
              <span class="is-vertical-align-top has-text-color-7">
                {{ App.PendingDocumentsScreen.ADD_PENDING_DOCUMENT }}
              </span>
            </div>
          </b-button>
        </div>
        <div
          class="has-text-color-7 is-6 has-text-weight-semibold is-flex is-align-items-center"
        >
          {{ General.NOTES }}
          <span v-if="!hasAdditionalDoc" class="optional-label ml-5">
            {{ General.OPTIONAL }}
          </span>
        </div>
        <b-input
          v-model="observation"
          type="textarea"
          customClass="has-text-justified"
          maxlength="1000"
          :placeholder="General.PLACEHOLDER.EMPTY_OBSERVATION"
        />
      </TimelineItem>
      <div class="buttons custom-margin mb-10">
        <b-button
          class="has-text-weight-semibold"
          :type="isContrast ? 'is-white-dark' : 'is-primary'"
          :disabled="isInvalidDocList"
          @click.stop="createPendency"
        >
          {{ General.SAVE }}
        </b-button>
        <b-button
          class="has-text-weight-semibold"
          :type="isContrast ? 'is-white-dark' : 'is-warning'"
          outlined
          @click.stop="emptyDocList"
        >
          {{ General.CANCEL }}
        </b-button>
      </div>
    </div>
    <b-tabs>
      <b-tab-item>
        <template slot="header">
          <span class="has-text-weight-bold">
            {{ App.PendingDocumentsScreen.REGISTERED_PENDENCIES.toUpperCase() }}
          </span>
        </template>
        <div
          v-for="pendingItem in getPendingList"
          :key="pendingItem.id"
          class="process-list"
        >
          <div>
            <p>
              <span class="has-text-weight-semibold">
                {{
                  new Date(pendingItem.status_date) | dateFormat("DD/MM/YYYY")
                }}
                às
                {{
                  `${new Date(pendingItem.status_date).getHours()}h${new Date(
                    pendingItem.status_date
                  ).getMinutes()}m`
                }}
                <span class="has-text-weight-semibold">por</span>
              </span>
              <span class="is-capitalized">
                {{ getOriginFormatted(pendingItem.capacity_id) }}
              </span>
            </p>
            <div
              v-for="(document, index) in pendingItem.pendency_documents"
              :key="index"
            >
              <p>
                <span class="has-text-weight-semibold"
                  >{{ `${App.PendingDocumentsScreen.PENDING_DOCUMENT}: ` }}
                </span>
                <span class="is-capitalized">
                  {{
                    document.is_complementary
                      ? App.PendingDocumentsScreen.COMPLEMENTARY_DOCUMENT
                      : `${document.document_name} - ${document.reason}`
                  }}
                </span>
              </p>
            </div>

            <p v-if="pendingItem.observation">
              <span class="has-text-weight-semibold"
                >{{ `${General.NOTES}: ` }}
              </span>
              <span class="is-capitalized">
                {{ pendingItem.observation }}
              </span>
            </p>
          </div>
          <div>
            <ActionsGrouper
              v-if="pendingItem.status === pendencyStatus.PENDING"
              :actions="actionList(pendingItem)"
            />
            <div v-else>
              <span>{{ pendingItem.status }}</span>
            </div>
          </div>
        </div>
      </b-tab-item>
    </b-tabs>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import { App, General } from "@/utils/constants";
import {
  PENDENCY_REASONS as pendencyReasons,
  PENDENCY_STATUS as pendencyStatus
} from "@/utils/enumerate";

import TimelineItem from "@/components/TimelineItem";

export default {
  name: "PendingDocumentsTab",
  components: {
    TimelineItem
  },

  data() {
    return {
      General,
      App,
      pendencyReasons,
      pendencyStatus,
      isLoading: false,
      pendingList: [],
      selectedDocList: [{ process_file_id: null, reason: null }],
      typeList: [],
      observation: "",
      reasonList: []
    };
  },

  computed: {
    ...mapGetters({
      isContrast: "isContrast",
      process: "getCurrentProcess",
      getPendingList: "getPendingList",
      getCapacityById: "getCapacityById",
      getPendingDocumentTypeList: "getPendingDocumentTypeList"
    }),

    isInvalidDocList() {
      return this.selectedDocList.some(
        doc =>
          doc.process_file_id === null ||
          (doc.process_file_id !== -99 && doc.reason === null)
      );
    },

    hasAdditionalDoc() {
      return this.selectedDocList.some(doc => doc.process_file_id === -99);
    },

    systemName() {
      const capacity = this.getCapacityById(-1);
      if (!capacity) return "";
      return `${capacity.entity.name}/${capacity.description}`;
    },

    stakeholderTagsData() {
      return this.process.cc;
    }
  },

  async beforeMount() {
    this.isLoading = true;
    await Promise.allSettled([
      this.requestPendingList(this.process.id),
      this.requestPendencyDocumentTypes(this.process.id)
    ]);
    this.isLoading = false;
  },

  methods: {
    ...mapActions({
      createPendencyRequest: "createPendencyRequest",
      requestPendingList: "requestPendingList",
      cancelPendency: "cancelPendency",
      requestPendencyDocumentTypes: "requestPendencyDocumentTypes"
    }),

    addPendingDocument() {
      this.selectedDocList.push({
        process_file_id: null,
        reason: null
      });
    },

    checkSingleDocument(listIndex) {
      return listIndex === 0 && this.selectedDocList.length === 1;
    },

    removeDocument(index) {
      if (this.selectedDocList.length > 1)
        this.selectedDocList.splice(index, 1);
    },

    clearDocument(index) {
      if (index === 0) {
        this.selectedDocList[index].process_file_id = null;
        this.selectedDocList[index].reason = null;
      }
    },

    async createPendency() {
      const docs = this.selectedDocList.map(doc =>
        doc.process_file_id === -99 ? { is_complementary: true } : doc
      );
      const dataToRequest = {
        process_id: this.process.id,
        origin: -1,
        capacity_id: this.process.capacity.id,
        pendency_documents: docs
      };

      if (this.hasAdditionalDoc && !this.observation) {
        return this.snackToast.open({
          message: App.PendingDocumentsScreen.EMPTY_PENDING_OBSERVATION,
          type: "is-danger",
          duration: 8000
        });
      }
      this.isLoading = true;

      this.observation && (dataToRequest.observation = this.observation);
      await this.createPendencyRequest(dataToRequest);

      await this.requestPendingList(this.process.id);

      this.emptyDocList();
      this.observation = "";
      this.isLoading = false;
    },

    emptyDocList() {
      this.selectedDocList = [
        {
          process_file_id: null,
          reason: null
        }
      ];
    },

    getOriginFormatted(capacityId) {
      const origin = this.getCapacityById(capacityId);
      return `${origin.entity.abbreviation}/${
        origin.abbreviation.includes("/")
          ? origin.abbreviation.split("/")[1]
          : origin.abbreviation
      } - ${origin.description}`;
    },

    actionList(item) {
      return [
        {
          icon: "cancel",
          label: this.General.CANCEL,
          callback: async () => {
            this.isLoading = true;
            await this.cancelPendency(item.id);
            await this.requestPendingList(this.process.id);
            this.isLoading = false;
          }
        }
      ];
    },

    pendingDocumentTypes(index) {
      const list = this.getPendingDocumentTypeList;
      const hasPosition = this.selectedDocList[index].process_file_id === -99;
      const additionalDoc =
        !this.hasAdditionalDoc || hasPosition
          ? [
              {
                id: -99,
                external_document_name:
                  App.PendingDocumentsScreen.COMPLEMENTARY_DOCUMENT
              }
            ]
          : [];
      return list.concat(additionalDoc);
    },

    resetReason(doc) {
      doc.reason = null;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.is-vertical-align-top {
  vertical-align: top;
}

.custom-decorate {
  text-decoration: none;
  font-weight: 600;

  &:hover,
  &:active,
  &:focus {
    background-color: transparent;
    box-shadow: none;
  }
}

.process-list {
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  padding: 10px 0px;
  justify-content: space-between;
  border-top: 1px solid $grey-lighter;
  border-bottom: 1px solid $grey-lighter;
}

.custom-margin {
  margin-left: 67.5px;
}

.tag-list {
  background-color: var(--color-2);
  border-color: snow;
}
</style>
